import React from 'react';
import LoginForm from '../../components/forms/LoginForm/LoginForm';
import { APP_CONFIG } from '../../config/constants';
import './LoginPage.css';
import logo from '../../assets/logo.png';

const LoginPage = () => {
    return (
        <div className="background-image">
            <div
                className="background-logo"
                style={{
                    backgroundImage: `url(${logo})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    opacity: 0.30,
                    position: 'absolute',
                    inset: 0,
                    zIndex: 0,
                }}
            />
            <div className="login-container">
                <div className="login-header">
                    <h1>Willkommen bei {APP_CONFIG.APP_NAME}</h1>
                    <p className="subtitle">ein Produkt der {APP_CONFIG.COMPANY_NAME}</p>
                </div>

                <div className="login-box">
                    <p>Bitte hier mit ihrem persönlichen Login starten.</p>
                    <LoginForm />
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
